/**
 * Tool approval query operations - Barrel export
 */

export {
  getApprovalById,
  getApprovalsByUser,
  getApprovalsByTool,
  getApprovalsByExpiration,
} from './get.js';
export { createApproval } from './create.js';
export {
  updateApproval,
  approveApproval,
  denyApproval,
  expireApproval,
  claimApprovalForExecution,
  recordApprovalExecutionResult,
} from './update.js';
export type { ClaimApprovalResult } from './update.js';
export { deleteApproval } from './delete.js';
